import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-[300px] mt-4 flex justify-center items-center bg-gray-700 rounded p-2 absolute top-[10px]" }

interface Props {
  message: String
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ToasterComponent',
  props: {
    message: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.message), 1))
}
}

})